module.exports = __webpack_public_path__ + "img/logo-login-page.88ccbe5b.png";